import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m15.027 13.847 3.57 3.569-1.18 1.178-3.568-3.569a7.47 7.47 0 0 1-4.681 1.641c-4.14 0-7.5-3.36-7.5-7.5s3.36-7.5 7.5-7.5 7.5 3.36 7.5 7.5c0 1.77-.614 3.397-1.64 4.68m-1.672-.619a5.8 5.8 0 0 0 1.646-4.062 5.83 5.83 0 0 0-5.833-5.833 5.83 5.83 0 0 0-5.833 5.833 5.83 5.83 0 0 0 5.833 5.833c1.58 0 3.012-.627 4.062-1.646z"
    }, null, -1)
  ]))]))
}
export default { render: render }